import React from "react";
import { Modal, Button } from "react-bootstrap";

const AssetDetailModal = ({ show, onHide, asset }) => {
  if (!asset) return null;

  const formatDate = (date) => {
    if (!date) return "N/A";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "N/A";
    }

    return parsedDate.toLocaleDateString("en-GB");
  };

  const formatDateTime = (date) => {
    if (!date) return "N/A";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "N/A";
    }

    return parsedDate.toLocaleString("en-GB");
  };

  const getAmount = () => {
    const cost = Number(asset?.assetType?.cost || 0);
    const quantity = Number(asset?.quantity || 0);

    return cost * quantity;
  };

  const DetailRow = ({ label, value }) => (
    <div className="col-md-6 mb-3">
      <div
        className="border rounded p-2 h-100"
        style={{
          backgroundColor: "#f8f9fa",
        }}
      >
        <div
          className="text-muted mb-1"
          style={{
            fontSize: "12px",
            fontWeight: "500",
          }}
        >
          {label}
        </div>

        <div
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: "#343a40",
            wordBreak: "break-word",
          }}
        >
          {value !== null && value !== undefined && value !== ""
            ? value
            : "N/A"}
        </div>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          <b>Asset Details</b>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* =====================================================
            ASSET INFORMATION
        ====================================================== */}

        <div className="mb-3">
          <h6
            className="border-bottom pb-2 mb-3"
            style={{
              color: "#4723d9",
              fontWeight: "600",
            }}
          >
            Asset Information
          </h6>

          <div className="row">
            <DetailRow label="Asset Name" value={asset?.assetType?.assetname} />

            <DetailRow label="Company" value={asset?.company} />

            <DetailRow
              label="Unit Cost"
              value={
                asset?.assetType?.cost !== undefined
                  ? `₹${Number(asset.assetType.cost).toLocaleString("en-IN")}`
                  : "N/A"
              }
            />

            <DetailRow label="Quantity" value={asset?.quantity} />

            <DetailRow
              label="Total Amount"
              value={`₹${getAmount().toLocaleString("en-IN")}`}
            />

            <DetailRow
              label="Purchased Date"
              value={formatDate(asset?.assetType?.purchasedDate)}
            />

            <DetailRow
              label="Purchased From"
              value={asset?.assetType?.purchasedFrom}
            />

            <DetailRow label="Asset ID" value={asset?._id} />
          </div>
        </div>

        {/* =====================================================
            ASSIGNMENT INFORMATION
        ====================================================== */}

        <div className="mb-3">
          <h6
            className="border-bottom pb-2 mb-3"
            style={{
              color: "#4723d9",
              fontWeight: "600",
            }}
          >
            Assignment Information
          </h6>

          <div className="row">
            <DetailRow label="Assigned User" value={asset?.user?.name} />

            <DetailRow label="User Email" value={asset?.user?.email} />

            <DetailRow label="User Phone" value={asset?.user?.phonenumber} />

            <DetailRow
              label="Assign From"
              value={formatDate(asset?.assignFromDate)}
            />

            <DetailRow
              label="Assign To"
              value={formatDate(asset?.assignToDate)}
            />

            <DetailRow
              label="Vehicle"
              value={asset?.vehicleData?.numberplate}
            />
          </div>
        </div>

        {/* =====================================================
            VEHICLE INFORMATION
        ====================================================== */}

        {asset?.vehicleData && (
          <div className="mb-3">
            <h6
              className="border-bottom pb-2 mb-3"
              style={{
                color: "#4723d9",
                fontWeight: "600",
              }}
            >
              Vehicle Information
            </h6>

            <div className="row">
              <DetailRow
                label="Vehicle Number"
                value={asset?.vehicleData?.numberplate}
              />

              <DetailRow label="Model" value={asset?.vehicleData?.model} />

              <DetailRow label="Year" value={asset?.vehicleData?.year} />

              <DetailRow
                label="Chassis Number"
                value={asset?.vehicleData?.chassisnumber}
              />

              <DetailRow label="Color" value={asset?.vehicleData?.color} />

              <DetailRow
                label="Vehicle Status"
                value={asset?.vehicleData?.status}
              />
            </div>
          </div>
        )}

        {/* =====================================================
            HUB INFORMATION
        ====================================================== */}

        {asset?.hubData && (
          <div className="mb-3">
            <h6
              className="border-bottom pb-2 mb-3"
              style={{
                color: "#4723d9",
                fontWeight: "600",
              }}
            >
              Hub Information
            </h6>

            <div className="row">
              <DetailRow label="Hub Name" value={asset?.hubData?.name} />

              <DetailRow label="Address" value={asset?.hubData?.address} />

              <DetailRow label="City" value={asset?.hubData?.city} />

              <DetailRow label="State" value={asset?.hubData?.state} />

              <DetailRow label="Country" value={asset?.hubData?.country} />

              <DetailRow label="Hub Status" value={asset?.hubData?.status} />
            </div>
          </div>
        )}

        {/* =====================================================
            APPROVAL INFORMATION
        ====================================================== */}

        <div className="mb-3">
          <h6
            className="border-bottom pb-2 mb-3"
            style={{
              color: "#4723d9",
              fontWeight: "600",
            }}
          >
            Approval Information
          </h6>

          <div className="row">
            <DetailRow
              label="Approved"
              value={
                asset?.approved ? (
                  <span className="badge bg-success">Yes</span>
                ) : (
                  <span className="badge bg-danger">No</span>
                )
              }
            />

            <DetailRow
              label="Approved By"
              value={asset?.approvedByData?.name}
            />

            <DetailRow
              label="Approved By Email"
              value={asset?.approvedByData?.email}
            />

            <DetailRow
              label="Approved By Phone"
              value={asset?.approvedByData?.phonenumber}
            />
          </div>
        </div>

        {/* =====================================================
            DESCRIPTION
        ====================================================== */}

        <div className="mb-3">
          <h6
            className="border-bottom pb-2 mb-3"
            style={{
              color: "#4723d9",
              fontWeight: "600",
            }}
          >
            Description
          </h6>

          <div
            className="border rounded p-3"
            style={{
              backgroundColor: "#f8f9fa",
              minHeight: "70px",
            }}
          >
            {asset?.description || "No description available."}
          </div>
        </div>

        {/* =====================================================
            SYSTEM INFORMATION
        ====================================================== */}

        <div>
          <h6
            className="border-bottom pb-2 mb-3"
            style={{
              color: "#4723d9",
              fontWeight: "600",
            }}
          >
            System Information
          </h6>

          <div className="row">
            <DetailRow
              label="Created At"
              value={formatDateTime(asset?.createdAt)}
            />

            <DetailRow
              label="Updated At"
              value={formatDateTime(asset?.updatedAt)}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssetDetailModal;
